import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ModalNewMessage from '@/components/modal/ModalNewMessage.vue';
import '@gohighlevel/ghl-ui/dist/style.css';
import { onMounted, provide, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewMessageModal',
    props: {
        route: Object,
        router: Object,
        emitter: Object,
        store: Object,
        user: Object,
    },
    setup(__props) {
        const props = __props;
        // inject current route
        provide('route', props.route);
        provide('router', props.router);
        provide('emitter', props.emitter);
        provide('store', props.store);
        provide('user', props.user);
        const showNewMessageModal = ref(false);
        function closeNewMessageModal() {
            showNewMessageModal.value = false;
        }
        function sendNewMessageConversation(conversationData) {
            var _a;
            (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.emit('send-new-message-conversation', conversationData);
        }
        onMounted(() => {
            var _a;
            (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.on('conversations-show-new-message-modal', () => {
                if (!showNewMessageModal.value) {
                    showNewMessageModal.value = true;
                    // console.log('New Message Opened')
                }
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(ModalNewMessage, {
                    "show-modal": showNewMessageModal.value,
                    onClose: closeNewMessageModal,
                    onSendNewConversation: sendNewMessageConversation
                }, null, 8, ["show-modal"])
            ]));
        };
    }
});
